'use client';

import { Skeleton } from '@/components/Skeleton';
import { useResponsive } from '@/modules/client';
import { getSlidesPerView } from '../BonusShopSlider/helpers';
import { CARD_HEIGHT } from './helpers';

interface BonusShopGridSkeletonProps {
  rows?: number;
}

export const BonusShopGridSkeleton = ({
  rows = 1,
}: BonusShopGridSkeletonProps) => {
  const { currentScreenType } = useResponsive();

  const cols = Math.max(1, Math.round(getSlidesPerView(currentScreenType)));

  return (
    <Skeleton.Container
      display="grid"
      gap={16}
      gridTemplateColumns={`repeat(${cols}, 1fr)`}
    >
      {new Array(cols * rows).fill(0).map((_, index) => (
        <Skeleton.Rect height={CARD_HEIGHT[currentScreenType]} key={index} />
      ))}
    </Skeleton.Container>
  );
};
